export default __webpack_public_path__ + "static/media/bkr.64525fec.svg";